import React, { useEffect, useRef, useState } from "react";
import {
  assetFamilyMaster,
  columnsTemplateCheckList,
  InspectionAssetMapMaster,
  InspectionMapMaster,
  TemplateMasterKey
} from "../../types/assetTypes";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/CommonSlice";
import {
  getFamilyAssetMasterDataList,
  getInspectionAssetMapById,
  getListOfInspectionTemplateMap,
  getListOfServiceTemplate,
  getListOfServiceTemplateMap,
  getTemplateDataById,
  getTemplateDataList,
  saveServiceTemplate,
  saveServiceTemplateMapping
} from "../../api/Services/masterServie";
import { enqueueSnackbar } from "notistack";
import { CustomMessage } from "../../const/Spinner";
import { Checkbox, FormControl, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Grid, Card, Button, FormControlLabel, FormGroup, IconButton, Popover, TextField } from "@mui/material";
import { DropdownChangeEvent } from "primereact/dropdown";
import ReusablePrimeButton from "../../Component/Buttons/ReusablePrimeButton";
import { DataTable } from "primereact/datatable";
import { assetMapBodyTableIcon, getInspectionAssetMapTemplateColumns, getServiceAssetMapTemplateColumns, getServiceTemplateColumns, getTemplateBButtonData, getTemplateButtonData, inspectionMapBodyTableIcon, templateBodyTableIcon } from "../../const/AssertData";
import ReusableDataTable from "../../Component/DataTable/ReusableDataTablePrime";
import CreateFaultAssetMapping from "./CreateFaultAssetMapping";
import CreateInspectionAssetMapping from "./CreateInspectionAssetMapping";
import FilterListIcon from '@mui/icons-material/FilterList';
import { handleInspetionMapFilter, handleLogisticsFilter } from "../../api/Services/assetServices";
import { RootState } from "../../store/Reduxstore";

interface InspectionAssetProps {
  setPathname: (path: string) => void;
}

const InspectionAssetMapping: React.FC = () => {

  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMapData, setSelectedMapData] = useState<InspectionAssetMapMaster>({

    inspectionAssetMapId: 0,
    assetName: "",
    familyAssetId: 0,
    familyName: "",
    inspectionTemplateId: 0,
    inspectionTemplateName: "",

  });



  const [selectedData, setSelectedData] = useState<InspectionAssetMapMaster>({

    inspectionAssetMapId: 0,
    assetName: "",
    familyAssetId: 0,
    familyName: "",
    inspectionTemplateId: 0,
    inspectionTemplateName: "",

  });
  const [products, setProducts] = useState<InspectionAssetMapMaster[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [templateAssetMapId, SetInspectionAssetMapId] = useState<number | null>(null);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });

  const handleEditInspectionMap = (inspectionAssetMapId: number, selectedRow: InspectionAssetMapMaster) => {
    SetInspectionAssetMapId(inspectionAssetMapId);
    setSelectedMapData(selectedRow);
    setOpen(true);
  };

  const inspectionMapBodyTemplate = (rowData: InspectionAssetMapMaster) => {
    const renderIconData = inspectionMapBodyTableIcon(
      handleEditInspectionMap,
      rowData
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const columns = getInspectionAssetMapTemplateColumns(inspectionMapBodyTemplate);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );



  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});
    setTempFilters({});
    // setCheckedValues([]);
    setSelectedValues([]);
    setFilterCol("");
    setSearchText("");
    setSubAnchorEl(null); // Close second popover if open
    setAnchorEl(null);
    setFilters({});    // Close first popover if open

    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };
  //for unique column names 

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  // const [filterCol, setFilterCol] = useState<string | null>(null);


  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  type Column = {
    key: string;
    label: string;
    values?: string[]; // Optional if values might not always exist
  };

  const openSubPopover = (
    event: React.MouseEvent<HTMLElement>,
    col: Column
  ) => {
    setSubAnchorEl(event.currentTarget);
    setFilterCol(col.key);
    setSelectedValues(col.values || []);
  };

  const closeSubPopover = () => {
    setSubAnchorEl(null);

  };
  const [columnns, setColumns] = useState<{ key: string; label: string }[]>([]);

  const closeVisibilityPopover = () => {
    setAnchorEl(null);

    setSearchText(''); // clear search input
  };

  type Filters = {
    [key: string]: {
      value: string[];
    };
  };


  type AssetItem = {
    id: number;
    name: string;
  };
  // const [searchText, setSearchText] = useState("");
  type AssetColumnData = {
    [key: string]: AssetItem[];
  };
  // const [filters, setFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  const [tempFilters, setTempFilters] = useState<Filters>({}); // ✨ temporary filters
  const [filterCol, setFilterCol] = useState<string>('');

  const [searchText, setSearchText] = useState('');
  useEffect(() => {
    console.log("Updated filterCol inside useEffect:", filterCol);
  }, [filterCol]);


  const [columnData, setColumnData] = useState<AssetColumnData>({});
  const currentColValues = (columnData[filterCol] || []).map((item: { name: string }) => item.name);
  const filteredValues = currentColValues.filter((val: string) =>
    val.toLowerCase().includes(searchText.toLowerCase())
  );



  const handleSubmit = (newFilters: Filters) => {
    console.log("Submitted Filters:", newFilters);
    setFilterData(newFilters);
    onFetchData(paginationData.page, paginationData.rows, newFilters);
    closeSubPopover();
    closeVisibilityPopover();
  };



  const handleCancel = () => {

    closeSubPopover();     // ✅ Close the popover
  };

  const openVisibilityPopover = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Anchor the popover

    // Fetch asset column data on click
    dispatch(setLoading(true));

    try {
      const response = await handleInspetionMapFilter(); // Get the full response

      console.log("API Response:", response); // Log the full response

      // Check if the response is valid and contains the 'data' object
      if (response && response.status && response.status.code === 200 && response.data) {
        const data = response.data;

        setColumnData(data); // Store the full data, if needed for later

        // Map through each key in the response's data object
        const formattedCols = Object.keys(data).map((key) => ({
          key,
          label: key.replace(/_/g, " "), // Make the key more readable by replacing underscores with spaces
          values: data[key].map((item: { name: string }) => item.name), // Access the 'name' property of each object
        }));

        console.log("Formatted Columns:", formattedCols); // Log formatted columns for debugging
        setColumns(formattedCols); // Store formatted columns in state
      } else {
        // If response does not contain valid data, show an error message
        CustomMessage("Failed to fetch valid data", "error", enqueueSnackbar); // Custom error message
      }
    } catch (error: any) {
      // Handle any errors and display custom error messages
      CustomMessage(error.message, "error", enqueueSnackbar); // Custom error message on failure
    } finally {
      // Stop the loading indicator when the request completes (success or error)
      dispatch(setLoading(false));
    }
  };
  // Generate button data dynamically
  const userDetails = useSelector((state: RootState) => state.auth);
  const buttonData = getTemplateBButtonData(
    handleClearFilter,
    () => setOpen(true),
    openVisibilityPopover,
    { role: userDetails.role.map(r => r.roleName) }

  );
  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          gap: "16px",
          width: "100%",
        }}
      >
        {/* Icons (Buttons) and Search Box in the Same Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
          </div>
          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={closeVisibilityPopover}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <FormGroup sx={{ p: 2, minWidth: 220 }}>
              {columnns.map((col) => (
                <Box
                  key={col.key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    px: 1,
                    py: 0.5,
                    '&:hover': { backgroundColor: '#f5f5f5', borderRadius: 1 },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFilterCol(col.key);

                    const currentChecked =
                      tempFilters[col.key]?.value || filters[col.key]?.value || [];

                    openSubPopover(e, col);
                  }}
                >
                  <Typography variant="body2">{col.label}</Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setFilterCol(col.key);

                      const currentChecked =
                        tempFilters[col.key]?.value || filters[col.key]?.value || [];


                      openSubPopover(e, col); // Pass the full Column object here
                    }}

                  >
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </FormGroup>
          </Popover>

          {/* Second Popover - value checkboxes */}
          <Popover
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubPopover}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            <Box sx={{ p: 2, width: 250 }}>
              <Typography variant="body2" gutterBottom>
                Filter by {filterCol.replace(/_/g, ' ')}
              </Typography>

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder={`Search ${filterCol}`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={
                        filteredValues.length > 0 &&
                        filteredValues.every((value) =>
                          tempFilters[filterCol]?.value?.includes(value)


                        )
                      }
                      onChange={(e) => {
                        const newChecked = e.target.checked
                          ? Array.from(new Set([
                            ...(tempFilters[filterCol]?.value),
                            ...filteredValues
                          ]))
                          : (tempFilters[filterCol]?.value).filter(
                            (v) => !filteredValues.includes(v)
                          );

                        setTempFilters((prev) => ({
                          ...prev,
                          [filterCol]: { value: newChecked },
                        }));
                      }}
                    />
                  }
                  label={<Typography variant="body2">Select All</Typography>}
                />
              </Box>

              <Box sx={{ mt: 1 }}>
                {filteredValues.map((value, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          tempFilters[filterCol]?.value?.includes(value)

                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const current = tempFilters[filterCol]?.value || []; // Ensure current is always an array

                          const updated = isChecked
                            ? [...current, value] // Add value if checked
                            : current.filter((v) => v !== value); // Remove value if unchecked

                          setTempFilters((prev) => ({
                            ...prev,
                            [filterCol]: { value: updated },
                          }));
                        }}
                      />
                    }
                    label={<Typography variant="body2">{value}</Typography>}
                  />
                ))}
              </Box>

              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const newFilters: Filters = {
                      ...filters,
                      ...tempFilters,
                    };
                    setFilters(newFilters);
                    handleSubmit(newFilters);
                    setSearchText('');
                    closeSubPopover();
                    closeVisibilityPopover();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Popover>
          {/* Right Side - Search Box */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search..."
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px",
              }}
            />
            <button
              onClick={handleSearch}
              style={{
                padding: "8px 12px",
                marginLeft: "8px",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#007bff", // Keeping the original color
                color: "white",
                cursor: "pointer",
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  };

  // const handleEditInspectionMap = async (inspectionAssetMapId: number) => {
  //     dispatch(setLoading(true));
  //     try {
  //       const response = await getInspectionAssetMapById(inspectionAssetMapId);
  //       let { data, status } = response;
  //       if (status.code === 200 && data) {
  //         setSelectedData(data);
  //         setOpen(true);
  //       } else {
  //         CustomMessage(status.message, "error", enqueueSnackbar);
  //       }
  //     } catch (error: any) {
  //       CustomMessage(error.message, "error", enqueueSnackbar);
  //     } finally {
  //       dispatch(setLoading(false));
  //     }
  //   };


  const handleEditServiceTemplate = (selectedRow: InspectionAssetMapMaster) => {
    setOpen(true);
    setSelectedMapData(selectedRow);
  };
  // Function to fetch data with pagination, global filter, and field filters
  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getListOfInspectionTemplateMap(page, rows, filter, searchTerm);
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
          Inspection Mapping
        </h2>

      </Box>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[
              // "assetOwnerName",
              // "harmonyCode",
              // "codeType",
              // "familyAsset",
            ]}
            header={header}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            filters={filterData}
            setFilters={setFilterData}
            pagination={paginationData}
            setPagination={setPaginationData}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditInspectionMap(rowData.inspectionAssetMapId, rowData);
            }}
          />
        </Box>
      ) : (
        <CreateInspectionAssetMapping
          setOpen={setOpen}
          selectedMapData={selectedMapData}
          setSelectedMapData={setSelectedMapData}

        />
      )}
    </div>
  );
};



export default InspectionAssetMapping;
